module.exports = __webpack_public_path__ + "img/Profile.97f122c4.svg";